import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";

const Layout = () => {
    const location = useLocation();

    // 사이드바를 보여줄 페이지들 정의
    const showSidebar = [
        "/tools",
        "/guide",
        "/about",
        "/faq",
        "/contact",
        "/privacy",
        "/terms",
    ].some((path) => location.pathname.startsWith(path));

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors">
            <Header />

            <div className="flex">
                {/* 데스크톱에서만 사이드바 표시 */}
                {showSidebar && (
                    <div className="hidden lg:block">
                        <Sidebar />
                    </div>
                )}

                <main
                    className={`flex-1 ${
                        showSidebar
                            ? "lg:ml-0"
                            : "container mx-auto px-4 lg:px-6"
                    }`}
                >
                    <div className={showSidebar ? "p-4 lg:p-6" : ""}>
                        <Outlet />
                    </div>
                </main>
            </div>

            <Footer />
        </div>
    );
};

export default Layout;
